<template>
  <div class="frame">
    <img :src="image" alt="" />
    <div class="name-label ts-leading-tight">
      <h1 class="ts-font-semibold ts-text-center ts-mb-0">{{ name }}</h1>
      <p class="ts-text-center ts-mb-0">
        <small
          ><i
            ><b>{{ dob }}</b></i
          ></small
        >
      </p>
      <p class="ts-text-center ts-mb-0">
        <small
          ><i
            ><b>{{ sex }}</b></i
          ></small
        >
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'imageFrame',
  props: {
    image: {
      type: String
    },
    name: {
      type: String,
      default: () => 'Unknow'
    },
    dob: {
      type: String,
      default: () => undefined
    },
    sex: {
      type: String,
      default: () => undefined
    }
  },
  data() {
    return {
      imag:
        'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRZ-E9SDEDulPGoTrUX-gAxgC9QiMYcQPTgZw&usqp=CAU'
    }
  }
}
</script>

<style scoped>
.frame {
  z-index: 500;
  width: 140px;
  height: 180px;
  border-radius: 5px;
  padding: 8px;
  background: rgb(255 255 255 / 0.7);
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 50px 2px rgb(0 0 0 / 0.3);
}

.frame > img {
  width: 100%;
  height: 100%;
  object-fit: fill;
  border-radius: 5px;
}
.frame > .name-label {
  position: absolute;
  background: rgb(255 255 255 / 0.9);
  top: 150px;
  right: -18px;
  width: 180px;
  min-height: 30px;
  padding: 5px;
  border-radius: 5px;
  backdrop-filter: blur(10px);
}
</style>
